import {IPmtFunctionProperties} from "./IPmtFunctionProperties";


export class PmtFunctionProperties {

    public readonly interestRateField: string;
    public readonly paymentPeriod: number;
    public readonly numberOfPaymentsField: string;
    public readonly loanAmountField: string;
    public readonly futureValue: number;
    public readonly paymentsDue: number;
    public readonly currency: string;

    constructor(interestRateField: string, paymentPeriod: number, numberOfPaymentsField: string,
                loanAmountField: string, futureValue: number, paymentsDue: number, currency: string) {
        this.interestRateField = interestRateField;
        this.paymentPeriod = paymentPeriod;
        this.numberOfPaymentsField = numberOfPaymentsField;
        this.loanAmountField = loanAmountField;
        this.futureValue = futureValue;
        this.paymentsDue = paymentsDue;
        this.currency = currency;
    }

    // fromJSON is used to convert a serialized version
    // of the Component to an instance of the class
    static fromJSON(json: IPmtFunctionProperties | string): PmtFunctionProperties {
        if (typeof json === 'string') {
            // if it's a string, parse it first
            return JSON.parse(json, PmtFunctionProperties.reviver);
        } else {
            // create an instance of the Component class
            let component = Object.create(PmtFunctionProperties.prototype);

            return Object.assign(component, json, {
                interestRateField: json.interestRateField,
                paymentPeriod: json.paymentPeriod,
                numberOfPaymentsField: json.numberOfPaymentsField,
                loanAmountField: json.loanAmountField,
                futureValue: json.futureValue,
                paymentsDue: json.paymentsDue,
                currency: json.currency
            });
        }
    }

    // reviver can be passed as the second parameter to JSON.parse
    // to automatically call Component.fromJSON on the resulting value.
    static reviver(key: string, value: any): any {
        return key === "" ? PmtFunctionProperties.fromJSON(value) : value;
    }
}
